<template>
  <UIDrawer
    :is-open
    :z-index
    direction="to-left"
    title="Notifications"
    with-back
    @close="handleClose"
  >
    <Notifications>
      <template #default="{ notifies, errors }">
        <AppNotifications
          :notifies
          :errors
          @click:item="handleClose"
        />
      </template>
    </Notifications>
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import Notifications from '../../components/Notifications.vue'
import { AppNotifications } from '@app'
import { UIDrawer } from '@ui/modals'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const handleClose = () => {
  props.modal.close()
}
</script>
